import memoizeOne from "memoize-one";
import { IStore } from "reducers";
import { IDeliveryPurchaseOrder } from "helpers/delivery-purchase-order";
import { getSnapshot, getHEAD } from "../mutate";

const DELIVERY_PURCHASE_ORDERS_OBJECT_ID_PATH = ["delivery_purchase_orders_ref", "ref", "object_id"];

const getCollectionDeliveryPurchaseOrdersRaw = (
    state: IStore,
    collectionId: string,
    poi?: string,
): IDeliveryPurchaseOrder[] => {
    const { mutate } = state;
    const collectionRoot = mutate.snapshots.get(collectionId);

    const purchaseOrders =
        getSnapshot(state, collectionRoot?.getIn(DELIVERY_PURCHASE_ORDERS_OBJECT_ID_PATH), poi)?.toJS() || [];

    return purchaseOrders;
};

const getCollectionDeliveryPurchaseOrdersEquality = (
    newArgs: Parameters<typeof getCollectionDeliveryPurchaseOrdersRaw>,
    oldArgs: Parameters<typeof getCollectionDeliveryPurchaseOrdersRaw>,
) => {
    const newCollectionHEAD = getHEAD(...newArgs);
    const oldCollectionHEAD = getHEAD(...oldArgs);

    let newDeliveryPurchaseOrdersSnapshot, oldDeliveryPurchaseOrdersSnapshot;
    if (newCollectionHEAD) {
        const newCollectionSnapshot = getSnapshot(...newArgs);
        newDeliveryPurchaseOrdersSnapshot = getSnapshot(
            newArgs[0],
            newCollectionSnapshot.getIn(DELIVERY_PURCHASE_ORDERS_OBJECT_ID_PATH),
            newArgs[2],
        );
    }

    if (oldCollectionHEAD) {
        const oldCollectionSnapshot = getSnapshot(...oldArgs);
        oldDeliveryPurchaseOrdersSnapshot = getSnapshot(
            oldArgs[0],
            oldCollectionSnapshot.getIn(DELIVERY_PURCHASE_ORDERS_OBJECT_ID_PATH),
            oldArgs[2],
        );
    }

    return newDeliveryPurchaseOrdersSnapshot === oldDeliveryPurchaseOrdersSnapshot;
};

export const getCollectionDeliveryPurchaseOrders = memoizeOne(
    getCollectionDeliveryPurchaseOrdersRaw,
    getCollectionDeliveryPurchaseOrdersEquality,
);
